import {
  AdjustmentSourceType,
  AdjustmentType,
  Adjustment,
} from '../types/generated/graphql-types'
import { getValueFromPercentage } from './getValueFromPercentage'

export const FEES_IN_ADJUSTMENT_TITLE = 'Fees in'

const FEES_IN_HUD_LINES = [801, 811, 812]

export function sumFeesInHudLinesDollars(
  lenderBaseFees:
    | Array<{
        hudLine?: number | null
        amount?: number | null
        feeType?: string | null
      }>
    | null
    | undefined,
  loanAmount: number
): number {
  if (!lenderBaseFees?.length || !loanAmount || loanAmount <= 0) {
    return 0
  }

  let sum = 0
  for (const fee of lenderBaseFees) {
    if (fee?.hudLine == null || !FEES_IN_HUD_LINES.includes(fee.hudLine)) {
      continue
    }
    const raw = fee.amount ?? 0
    const dollars =
      fee.feeType === 'Percentage'
        ? getValueFromPercentage(loanAmount, raw)
        : raw
    sum += dollars
  }

  return sum
}

/**
 * Converts rolled-in fee dollars to margin points: (sum / loanAmount) * 100, 3 decimal places.
 */
export function feesInDollarsToMarginPoints(
  sumDollars: number,
  loanAmount: number
): number {
  if (!sumDollars || !loanAmount || loanAmount <= 0) {
    return 0
  }

  return parseFloat(((sumDollars / loanAmount) * 100).toFixed(3))
}

export function buildFeesInMarginAdjustmentObject(
  marginPoints: number
): Adjustment | null {
  if (!marginPoints) {
    return null
  }

  return {
    title: FEES_IN_ADJUSTMENT_TITLE,
    amount: marginPoints,
    isHidden: false,
    isStop: false,
    isCompAdjustment: true,
    filter: null,
    adjustmentSourceType: AdjustmentSourceType.BusinessRule,
    adjustmentType: AdjustmentType.Margin,
  }
}
